import { neon } from '@neondatabase/serverless';

const sql = neon(process.env.REACT_APP_NEON_DATABASE_URL);

export const createSession = async () => {
  const token = Math.random().toString(36).substring(2) + Date.now().toString(36);
  
  try {
    await sql`
      INSERT INTO sessions (token, current_step, completed, created_at)
      VALUES (${token}, 0, FALSE, NOW())
    `;
    return token;
  } catch (error) {
    console.error('Error creating session:', error);
    throw error;
  }
};

export const getSession = async (token) => {
  try {
    const session = await sql`
      SELECT * FROM sessions WHERE token = ${token}
    `;
    return session[0];
  } catch (error) {
    console.error('Error getting session:', error);
    throw error;
  }
};

export const updateSession = async (token, currentStep, completed = false) => {
  try {
    await sql`
      UPDATE sessions 
      SET current_step = ${currentStep}, 
          completed = ${completed},
          last_updated = NOW()
      WHERE token = ${token}
    `;
  } catch (error) {
    console.error('Error updating session:', error);
    throw error;
  }
};

export const getSessionResults = async (token) => {
  try {
    const results = await sql`
      SELECT * FROM rankings 
      WHERE session_id = ${token} 
      ORDER BY created_at ASC
    `;
    return results;
  } catch (error) {
    console.error('Error getting session results:', error);
    throw error;
  }
};